export enum UserRole {
  Anonymous = "Anonymous",
  User = "User",
  SuperAdmin = "SuperAdmin",
  Manager = "Manager",
  Employee = "Employee",
  Owner = "Owner",
  Accountant = "Accountant",
  Integration = "Integration",
  Admin = "Admin",
}